/**
 * Person-name formatting shared across the apps. Centralised so "how a name
 * renders" lives in one place instead of a dozen inline
 * `` `${firstName} ${lastName}`.trim() `` copies that drift apart on null
 * handling.
 */

/**
 * Join a person's first and last name into a trimmed display string.
 * Null/undefined/whitespace parts are dropped, so a missing last name yields
 * just the first name (and both missing yields ""). Callers that need a
 * non-empty fallback (phone, "Guest", "?") apply it themselves.
 */
export function formatFullName(person: {
  firstName?: string | null;
  lastName?: string | null;
}): string {
  return [person.firstName, person.lastName]
    .map((part) => part?.trim() ?? "")
    .filter(Boolean)
    .join(" ");
}
